import common from './common';

const CONFIG = {
  ...common,
  coreCpcEnvironment: 'production',
  coreCpcUrl: 'https://common-payment.xfinity.com/',
  xmCpcEnvironment: 'production',
  xmCpcUrl: 'https://common-payment.xfinity.com/',
  cimaClientId: 'my-account-web',
  cottonClientId: 'dss-mw-pci-prod',
  firebaseEnabled: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC-fCKK7R78iAwv_Q1zkW0mCes3J2052P0',
    authDomain: 'dss-maw-pci-prod-732417.firebaseapp.com',
    projectId: 'dss-maw-pci-prod-732417',
    storageBucket: 'dss-maw-pci-prod-732417.firebasestorage.app',
    messagingSenderId: '695475537533',
    appId: '1:695475537533:web:50527abbb385ed9c3f1314',
    measurementId: 'G-6RTLBSM5R4',
  },
};

export default CONFIG;
